import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "./users.module.css";

import GridTable from "../../../Components/CommonTable/GridTable/GridTable";
import Filters from "../../../Components/Common/Filters/Filters";
import {UsersApi} from '../../../App/api/users.api.js'
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";
import filters  from "./Filters.js";
import MenuApi from "../../../App/api/menu.apis.js";
import { useSelector } from "react-redux";
const Users = ({meta}) => {
  const [toggleUsers, SetToggleUser] = useState(true);
  const [gridToggle, SetGridToggle] = useState(false);  
  
  const debounceTimeout=useRef()
  const [search, setSearch] = useState("");  
  const [pagination,setPagination]=useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: ""
  })
 
  const {value, fetchAllData } = useFetchAll(() =>UsersApi.getAllCustomer(pagination,search));
  filters.filters[1].options= useSelector((state)=>state.country.data.map((d)=>{return {name:d.name,code:d._id}}))
  // console.log('CountryData',filters);
  
const getCity=async()=>{
try {
  const res=await MenuApi.getAllCity(pagination.filter.country)
  // console.log('CityData',res);
  filters.filters[2].options=res.data.data.map((d)=>{return {name:d.name,code:d._id}})
  
} catch (error) {
  // console.log(error);
  
}
}

  useEffect(()=>{
if (pagination.filter?.country) {
  getCity()
}
  },[pagination.filter?.country])
  

  const handlePagination=(data)=>{
    // console.log(data);
    
    if (data.clearPagination) {
      setPagination(data.clearPagination)
      return
    }
    
    setPagination((prev)=>{
        let copyfilter={...prev.filter}
        // copyfilter[]
       
        if (data.filter) {
          // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
          // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
          
          if (copyfilter[Object.keys(data.filter)[0]]) {
            copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
            
          }else{

            copyfilter={...data?.filter,...copyfilter}
          }
        
        }
       
  
        return{
          page:data.page?data.page:prev.page,
          limit:data.limit?data.limit:prev.limit,
          sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
          filter:copyfilter
        }
  
      })
    }

    
  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
}, []);

 filters.handleSearch = useCallback((s) => {
  if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
  } 
  debounceTimeout.current = setTimeout(() => {
      handleSearch(s); 
  }, 1500);
}, [handleSearch]);


filters.handleClearFilter=()=>{
const clearPagination=  {
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  }
  // console.log('clearPagination',clearPagination);
  handlePagination && handlePagination({clearPagination})
}
filters.handleFilter=(name,value)=>{
console.table('name,value',name,value);
let data={}
if (name==='search_by') {
  data.sortOrder=value.code
}
else{
 
  const filter={}
  filter[name]=value.code?value.code:value
  data.filter=filter
  
}

// console.log('data',data);
 handlePagination && handlePagination(data)


}



useEffect(() => {
  fetchAllData()
}, [pagination,search]);

// console.log("User::value", value);arameter) sortOrder: string

  return (
    <>
      <CommonLayout />
      {/* {JSON.stringify(value)} */}

      <div style={{ paddingBottom: "4rem" }}>
       
        {/* <Filters
          SetGridToggle={SetGridToggle}
          gridToggle={gridToggle}
          type={"users"}
        /> */}

        <div className={styles.users_toggle_container}>
          {/* <span
            style={{ color: toggleUsers ? "#e34e4e" : "var(--text-color3)" }}
            // onClick={() => SetToggleUser(true)}
            onClick={() => SetPagination(3,5,"desc")}
          >
            ACTIVE USERS
          </span> */}
          {/* <span
            style={{ color: !toggleUsers ? "#e34e4e" : "var(--text-color3)" }}
            // onClick={() => SetToggleUser(false)}
            onClick={() => SetPagination(2,5,"desc")}
          >
            BLOCKED USERS
          </span> */}
        </div>
    
        <div style={{ padding: "2rem" }}>
          <GridTable 
            FilterData={filters} 
            handlePagination={handlePagination}
            isGrid={gridToggle} 
            SetGridToggle={SetGridToggle} 
            type={"users"} 
            value={value} 
            />
        </div>
      </div>
    </>
  );
};

export default Users;
